module.exports = __webpack_public_path__ + "static/media/-_Welfare.6cbec175.png";